import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import notification from "../../../helpers/notification";

// Lets a page show a toast *after* navigating (a toast fired just before a
// route change would die with the old page's container). The sender navigates
// with { state: { tspFlash: { type, message } } } via navigateWithFlash();
// the destination page calls this hook once, which shows it and clears the state
// so a refresh/back doesn't repeat it.
//
// REQUIREMENT for destination pages: render ONE <ToastContainer /> that is (a) a stable
// sibling that is never remounted between the page's loading/error/loaded states and
// (b) placed BEFORE the content that calls this hook, so it has subscribed by the time
// the effect fires. See TspAdviceRepositoryPage / TspAdviceDetailPage for the pattern.
export function navigateWithFlash(navigate, to, type, message) {
  navigate(to, { state: { tspFlash: { type, message } } });
}

export default function useTspFlashNotice() {
  const location = useLocation();
  const navigate = useNavigate();
  const shownFor = useRef(null);

  useEffect(() => {
    const flash = location.state?.tspFlash;
    if (!flash || shownFor.current === location.key) return;
    shownFor.current = location.key;
    notification(flash.type, flash.message);
    navigate(`${location.pathname}${location.search}`, { replace: true, state: null });
  }, [location, navigate]);
}
